import * as angular from 'angular';
import * as _ from 'lodash';

import { IUserService, IApplicationService } from '../../services';
import { ComponentDefinition, IUserModel, ApplicationDto } from '../../models';

class UserPreviewController implements angular.IComponentController {
    user: IUserModel;
    userName: string;
    isLoading: boolean;
    isPictureLoaded: boolean;

    static $inject = ['userService', 'applicationService'];

    constructor(private _userService: IUserService,
        private _applicationService: IApplicationService) {
    }

    $onInit() {
        //this.user = undefined;
        if (!this.user && this.userName) {
            this.loadUserByName();
        } else {
            this.isLoading = true;
            this.loadPicture()
                .finally(() => this.isLoading = false);
        }
    }

    private loadUserByName(): void {
        this.isLoading = true;

        this._userService
            .getUserModelByUserName(this.userName)
            .then(data => {
                this.user = data;
                this._applicationService
                    .getForUser(data.userName, (applications: ApplicationDto[]) => {
                        this.isLoading = false;
                        this.user.applications = applications.map(a => a.application);
                        const allRoles = [].concat(...applications.map(a => a.roles[this.user.userName]));
                        this.user.roles = _.uniq(allRoles);
                    });
                return this.loadPicture();
            })
            .finally(() => this.isLoading = false);
    }

    private loadPicture(): angular.IPromise<void> {
        return this._userService
            .getPicture(this.user.userName)
            .then(data => {
                this.user.pictureStyle = data
                    ? { 'background-image': `url('data:image/false;base64,${data}')` }
                    : '';
                this.isPictureLoaded = true;
            });
    }
}

export const wtUserPreview: ComponentDefinition = {
    componentId: 'wtUserPreview',
    controller: UserPreviewController,
    template: require('./userPreview.component.html'),
    controllerAs: 'vm',
    bindings: {
        user: '=',
        userName: '='
    }
};
